import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/pro-solid-svg-icons';
import { Form } from 'react-bootstrap';
import './style.scss';

const Index = ({
  data,
  setData,
  style,
  onCheckChange,
  onSelectChange,
  onExpandChange
}) => {

  const handleCheckChange = (treeItem, newCheckedState) => {
    var tempTreeViewData = data.map(item => item.id == treeItem.id ? { ...item, isChecked: newCheckedState, checkIndeterminate: false } : item);

    if (treeItem.childIds?.length > 0) {
      tempTreeViewData = updateChildrenCheckState(tempTreeViewData, treeItem, newCheckedState);
    }

    if (treeItem.parentId) {
      tempTreeViewData = updateParentCheckState(tempTreeViewData, treeItem);
    }
    setData(tempTreeViewData);

    if (!onCheckChange) return;

    onCheckChange(getCheckedChildren([], treeItem, newCheckedState));
  };

  const getCheckedChildren = (checkedItemList, treeItem, checkState) => {

    if (treeItem.childIds?.length > 0) {
      for (var i = 0; i < treeItem.childIds.length; i++) {
        var childItem = data.find(t => t.id == treeItem.childIds[i]);
        if (childItem) getCheckedChildren(checkedItemList, childItem, checkState);
      }
    } else {
      checkedItemList.push({ id: treeItem.id, isChecked: checkState });
    }

    return checkedItemList;
  };

  const updateChildrenCheckState = (tempData, treeItem, checkedState) => {

    if (treeItem.childIds?.length > 0) {
      for (var i = 0; i < treeItem.childIds.length; i++) {
        tempData = tempData.map(t => treeItem.childIds.includes(t.id) ? { ...t, isChecked: checkedState } : t);

        var childItem = tempData.find(t => t.id == treeItem.childIds[i]);
        if (childItem) {
          childItem.checkIndeterminate = false;
          tempData = updateChildrenCheckState(tempData, childItem, checkedState);
        }
      }
    }
    return tempData;
  };

  const updateParentCheckState = (tempData, treeItem) => {
    var parentItem = tempData.find(t => t.id == treeItem.parentId);
    if (!parentItem) return tempData;

    var checkedChildrenCount = tempData.filter(t => parentItem.childIds.includes(t.id) && t.isChecked).length;

    if (checkedChildrenCount == parentItem.childIds.length) {
      parentItem.isChecked = true;
      parentItem.checkIndeterminate = false;
    } else {

      parentItem.isChecked = false;

      if (checkedChildrenCount > 0 || tempData.filter(t => parentItem.childIds.includes(t.id) && t.checkIndeterminate).length > 0) {
        parentItem.checkIndeterminate = true;
      } else {
        parentItem.checkIndeterminate = false;
      }
    }

    if (parentItem.parentId) updateParentCheckState(tempData, parentItem);
    return tempData;
  };

  const handleExpand = (treeItem) => {
    setData(data.map(item => item.id == treeItem.id ? { ...item, isExpanded: !item.isExpanded } : item));

    if (!onExpandChange) return;
    onExpandChange({ name: treeItem.name, id: treeItem.id });
  };

  const handleSelect = (treeItem) => {
    if (!onSelectChange) return;
    onSelectChange({ name: treeItem.name, id: treeItem.id });
  };

  const drawTreeItem = (treeItem) => {
    if(treeItem.isHidden) return;
    return (
      <>
        <div className={`d-flex flex-row align-items-center gap-1 ${treeItem.childIds?.length > 0 ? 'mt-2' : ''}`} >
          {treeItem.childIds?.length > 0 && <div className='expandButton' onClick={() => handleExpand(treeItem)}>
            <FontAwesomeIcon style={{ fontSize: '16px', padding: '4px' }} icon={treeItem.isExpanded ? faMinus : faPlus} />
          </div>}

          {style.toLowerCase() == 'checkbox' &&
            <Form.Check type='checkbox' id={treeItem.childIds?.length > 0 ? `${treeItem.id}_noCheck` : treeItem.id} className={`filterCheckbox ${!treeItem.childIds?.length && 'ml-2'}`} >
              <Form.Check.Input type='checkbox' style={{ marginRight: '5px' }}
                id={treeItem.id}
                checked={treeItem.isChecked}
                onChange={() => handleCheckChange(treeItem, !treeItem.isChecked)}
                ref={element => element && (element.indeterminate = treeItem.checkIndeterminate)} />
              <Form.Check.Label style={{ cursor: 'pointer', userSelect: 'none' }}
                className='w-fitcontent'
                id={`${treeItem.id}_label`}
                onClick={() => { handleExpand(treeItem); treeItem.childIds?.length > 0 ? undefined : handleSelect(treeItem); }}>{treeItem.name}</Form.Check.Label>
            </Form.Check>}

          {style.toLowerCase() == 'select' &&
            <div style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => { handleExpand(treeItem); treeItem.childIds?.length > 0 ? undefined : handleSelect(treeItem); }}>{treeItem.name}</div>}
        </div>

        {treeItem.childIds?.length > 0 && treeItem.isExpanded &&
          <div className='d-flex flex-column' style={{ marginLeft: '1.74rem' }}>
            {treeItem.childIds.map((childId) => drawTreeItem(data.find(t => t.id == childId)))}
          </div>}
      </>
    );
  };

  return (
    <div className='d-flex flex-column'>
      {data.filter(t => !t.parentId).map((treeItem) => (drawTreeItem(treeItem))
      )}
    </div>
  );
};

Index.propTypes = {
  data: PropTypes.array.isRequired,
  setData: PropTypes.any,
  style: PropTypes.string,
  handleOnSelect: PropTypes.func,
  handleOnExpand: PropTypes.func,
  onCheckChange: PropTypes.func,
  onSelectChange: PropTypes.func,
  onExpandChange: PropTypes.func
};

export default Index;